import { render, staticRenderFns } from "./ModalText.vue?vue&type=template&id=958ce70c&scoped=true&"
import script from "./ModalText.vue?vue&type=script&lang=js&"
export * from "./ModalText.vue?vue&type=script&lang=js&"
import style0 from "./ModalText.vue?vue&type=style&index=0&id=958ce70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958ce70c",
  null
  
)

export default component.exports